import { z } from 'zod';
import { PortalConsumerSchema, PortalEntityTypeSchema, } from '../../base/portal.js';
import { PortalZoneSchema } from '../../base/zones.js';
export const ListUserPortalsRequestPathSchema = z.object({
    email: z.string().transform((val) => decodeURI(val)),
    entityType: PortalEntityTypeSchema,
});
export const ListUserPortalsRequestQueryStringSchema = z.object({
    externalUserId: z.string().optional(),
    includeInactive: z.coerce.boolean(),
    zone: PortalZoneSchema.optional(),
});
export const ListUserPortalsRequestSchema = ListUserPortalsRequestPathSchema.merge(ListUserPortalsRequestQueryStringSchema);
export const ListUserPortalsResponseSchema = z.object({ portals: z.array(PortalConsumerSchema) });
export const ListUserPortalsApiSchema = {
    params: ListUserPortalsRequestPathSchema,
    query: ListUserPortalsRequestQueryStringSchema,
    response: ListUserPortalsResponseSchema,
};
